<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <template v-if="isHeJia">
          <div class="title-des">
            此订单未计算出运单价格，请手动计算并填入价格，系统会自动运单 价格以及运单信息计算总价
          </div>
          <el-row :gutter="20" class="input-price">
            <el-form ref="oldForm" :model="oldForm" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item prop="sourceFee">
                  <el-input
                    type="text"
                    clearable
                    @input="searchPrice"
                    placeholder="请输入价格"
                    v-model="oldForm.sourceFee"
                    maxlength="50"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
        <template
          v-loading="loading"
          element-loading-text="价格计算中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.4)">
          <div class="title-box">
            客户需支付（含票）：
            <span class="price">{{ form.payableFee }}元</span>
          </div>
          <el-row class="price-des-box">
            <el-col :span="12" class="label-val">
              <span class="label">初始运单价格：</span>
              <span class="value">￥{{ form.sourceFee }}</span>
            </el-col>
            <el-col :span="12" class="label-val">
              <span class="label">优惠/加价后价格：</span>
              <span class="value">￥{{ form.fee }}</span>
            </el-col>
            <el-col :span="12" class="label-val">
              <span class="label">代理商运营费：</span>
              <span class="value">￥{{ form.agentFee }}</span>
            </el-col>
            <el-col :span="12" class="label-val">
              <span class="label">发票价格：</span>
              <span class="value">￥{{ form.invoiceFee }}</span>
            </el-col>
          </el-row>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {validatePrice} from "@/utils/validate";
import {orderFreight, orderFreightPreFee} from "./api";
import {setFreightId} from "@/views/commonApi";
import {debounce} from "lodash";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        disabled: true,
        width: "500px",
        show: false,
        title: "确认价格",
        cancelTxt: "上一步",
        confirmTxt: "确认价格并提交",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        "agentFee": "",
        "fee": "",
        "invoiceFee": "",
        "payableFee": "",
        "sourceFee": ""
      },
      oldForm: {
        sourceFee: ''
      },
      rules: {
        sourceFee: [
          { required: true, message: "价格不能为空" },
          {validator: validatePrice, trigger: "blur"}
        ],
      },
      loading: false,
      isHeJia: false
    };
  },
  // watch: {
  //   "oldForm.sourceFee": function (val) {
  //     if (val && priceReg.test(value)) {
  //       this.searchPrice()
  //     }
  //   }
  // },
  mounted() {},
  methods: {
    init(oldForm, data) {
      this.oldForm = Object.assign({}, oldForm);
      if (data?.sourceFee) {
        this.dialogObj.title = "请确认价格"
        this.form.sourceFee = data.sourceFee;
        this.oldForm.sourceFee = data.sourceFee;
        this.dialogObj.disabled = false
        this.isHeJia = false
      } else {
        this.dialogObj.title = "待核价"
        this.isHeJia = true
        this.dialogObj.disabled = true
      }
      this.form = Object.assign({}, data);
      this.dialogObj.show = true;
    },
    searchPrice: debounce(function (val) {
      if (!val) {
        this.form.agentFee = ''
        this.form.fee = ''
        this.form.invoiceFee = ''
        this.form.payableFee = ''
        this.form.sourceFee = ''
      }
      this.$refs.oldForm.validate((valid) => {
        if (valid) {
          this.loading = true
          orderFreightPreFee(this.oldForm).then((res) => {
            if (res.code === 200) {
              this.form = Object.assign({}, res.data);
              this.dialogObj.disabled = false
            }
          }).finally((e) => {
            this.loading = false
          });
        }
      })
    }, 500),
    submitForm() {
      this.$confirm(`确定下单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.dialogObj.btnLoading = true;
        setFreightId().then((res) => {
          if (res.code === 200) {
            this.oldForm.orderId = res.data;
            // this.form.agentFee = ''
            // this.form.fee = ''
            // this.form.invoiceFee = ''
            // this.form.payableFee = ''
            // this.form.sourceFee = ''
            let params = {
              ...this.oldForm,
              agentFee: this.form.agentFee, // 代理商运营费
              fee: this.form.fee, // 优惠/加价后价格
              invoiceFee: this.form.invoiceFee, // 发票价格
              payableFee: this.form.payableFee, // 发货人应付金额
            }
            orderFreight(params)
                .then((res) => {
                  this.dialogObj.btnLoading = false;
                  if (res.code === 200) {
                    this.$confirm(
                        `<div class="dialog-confirm">
                        <div class="dialog-confirm-content">
                          <i class="custom-icon el-icon-success"></i>
                          <span class="custom-tip">下单成功</span>
                        </div>
<!--                        <div class="dialog-confirm-des">-->
<!--                          请告知货主使用下单手机号码登录拼满运微信小程序后，在小程序待支付订单页面中完成支付。-->
<!--                        </div>-->
                      </div>`,
                        "系统提示",
                        {
                          confirmButtonText: "我知道了",
                          showCancelButton: false,
                          dangerouslyUseHTMLString: true,
                          type: "none",
                          center: true,
                        }
                    ).finally(() => {
                      this.dialogObj.show = false;
                      this.$emit("refreshData");
                    });
                  }
                })
                .catch((e) => {
                  this.dialogObj.btnLoading = false;
                });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
    .label{
      width: 1.2rem;
      text-align: right;
    }
  }
  .title-box {
    padding: 0rem 0 0.2rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
    .price{
      font-size: 0.16rem;
      color: #0a65f0;
    }
  }
  .title-des{
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.6);
  }
  .input-price{
    margin: 0.1rem 0;
  }
  .price-des-box{
    background-color: rgba(0,0,0,0.05);
    padding-top: 0.1rem;
    padding-left: 0.1rem;
    border-radius: 5px;
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .label-val{
    .label{
      color: #000000;
    }
    .value{
      color: #0a65f0;
      font-size: 0.14rem;
    }
  }
}
</style>
